import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { ColumnVersion } from '../types'
import { formatDateHeader } from '../utils/formatters'

interface VersionMilestoneProps {
    version: ColumnVersion
}

const VersionMilestone = ({ version }: VersionMilestoneProps) => {
    const userName = version.createdBy?.name || 'Unknown user'
    const headerText = formatDateHeader(version.createdAt, userName)

    return (
        <Stack gap={1.5}>
            {/* Header: Date and User */}
            <Typography variant="14x500" color="figma.grayscale.textHier1">
                {headerText}
            </Typography>

            {/* Milestone card */}
            <Box
                sx={{
                    ml: 2,
                    p: 2,
                    borderRadius: 2,
                    bgcolor: 'figma.primary3',
                    borderLeft: '4px solid',
                    borderColor: 'figma.primary',
                }}
            >
                <Stack direction="row" alignItems="flex-start" gap={1.5}>
                    <Box
                        sx={{
                            width: 10,
                            height: 10,
                            borderRadius: '50%',
                            backgroundColor: 'figma.primary',
                            flexShrink: 0,
                            mt: 0.5,
                        }}
                    />
                    <Stack gap={0.25}>
                        <Typography variant="14x600" color="figma.primary">
                            Version {version.versionNumber} Saved
                        </Typography>
                        <Typography variant="12x400" color="figma.grayscale.textHier2">
                            {version.columnTitle}
                        </Typography>
                        {version.note && (
                            <Typography variant="12x400" color="figma.grayscale.textHier3" fontStyle="italic">
                                {version.note}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            </Box>
        </Stack>
    )
}

export default VersionMilestone
